"use client";
import React, { useRef, useState, useEffect } from "react";
import { Popover } from "antd";
import { useJobTrans } from "../jobTransProvider";
import Lottie from "lottie-web";

import styles from "./Translation.pc.module.scss";

export default function Translation({ aiTranslate }) {
  const { transData, setTransData } = useJobTrans();
  const containerRef = useRef(null);
  const [open, setOpen] = useState(false);
  const translationRef = useRef(null);
  let timer = useRef(null);

  useEffect(() => {
    let animation = null;

    if (timer.current) {
      clearTimeout(timer.current);
    }
    timer.current = setTimeout(() => {
      animation = Lottie.loadAnimation({
        container: containerRef.current,
        renderer: "svg",
        loop: false,
        autoplay: false,
        animationData: require("images/jobDetail.json")
      });
      animation.play();
    }, 500);

    return () => {
      animation?.destroy();
      clearTimeout(timer.current);
    };
  }, [open]);

  useEffect(() => {
    if (!transData.isOriginal) {
      setOpen(true);
    } else {
      setOpen(false);
    }
  }, [transData.isOriginal]);

  if (transData.showButton) {
    const content = (
      <div className={styles.tips}>
        <div className={styles.tipsContent}>
          <div ref={containerRef} className={styles.svgBox}></div>
          {aiTranslate?.translateText}
        </div>
      </div>
    );
    return (
      <div className={styles.translation}>
        <div
          className={styles.transButton}
          onClick={() => {
            setTransData((state) => ({
              ...state,
              isOriginal: !state.isOriginal
            }));
          }}
          ref={translationRef}
        >
          <Popover
            trigger='click'
            placement='bottom'
            getPopupContainer={(node: HTMLElement) => node?.parentNode as any}
            align={{
              offset: [-12, 6]
            }}
            title={null}
            content={content}
            open={open}
            onOpenChange={(state) => open && setOpen(state)}
            overlayClassName={styles.overlayOriginalWrap}
          >
            <span className={styles.button}>
              <svg
                className={styles.svg}
                xmlns='http://www.w3.org/2000/svg'
                width='20'
                height='20'
                viewBox='0 0 20 20'
                fill='none'
              >
                <path
                  d='M13.4813 8.56092L13.5297 8.64404L17.3081 16.2009C17.3954 16.3735 17.4132 16.5729 17.3578 16.7582C17.3025 16.9435 17.1782 17.1005 17.0106 17.1969C16.843 17.2934 16.6448 17.3219 16.4568 17.2766C16.2688 17.2313 16.1054 17.1157 16 16.9536L15.9562 16.8765L15.0312 15.0273H10.6755L9.75126 16.8765C9.66854 17.0423 9.52776 17.172 9.35569 17.2408C9.18362 17.3096 8.99226 17.3128 8.81799 17.2498L8.73713 17.2143C8.5716 17.1314 8.44224 16.9907 8.37357 16.8188C8.30489 16.647 8.3017 16.4558 8.36458 16.2818L8.39934 16.2009L12.1778 8.64404C12.2369 8.52579 12.3259 8.42511 12.4361 8.35205C12.5463 8.279 12.6737 8.23612 12.8056 8.22771C12.9376 8.2193 13.0694 8.24564 13.188 8.30411C13.3065 8.36258 13.4077 8.45113 13.4813 8.56092ZM7.56431 2.18066C7.74927 2.18087 7.92773 2.24891 8.06589 2.37189C8.20405 2.49487 8.29231 2.66424 8.31395 2.84793L8.31924 2.93635V3.69203H12.0977C12.2903 3.69225 12.4755 3.766 12.6156 3.89822C12.7556 4.03044 12.8399 4.21116 12.8512 4.40343C12.8625 4.59571 12.7999 4.78504 12.6763 4.93274C12.5527 5.08044 12.3773 5.17537 12.1861 5.19812L12.0977 5.20341H11.0231C10.5954 7.19442 9.74778 9.07126 8.53688 10.7086C8.65401 10.8423 8.77492 10.9731 8.8996 11.1015C9.0389 11.2457 9.1152 11.4394 9.11173 11.6398C9.10825 11.8403 9.02529 12.0312 8.88109 12.1704C8.73689 12.3097 8.54326 12.386 8.3428 12.3826C8.14234 12.3791 7.95146 12.2961 7.81217 12.1519L7.56431 11.8874C6.37055 13.1892 4.94729 14.26 3.36572 15.0462C3.2768 15.0904 3.18006 15.1166 3.08101 15.1234C2.98196 15.1301 2.88255 15.1173 2.78845 15.0857C2.69435 15.054 2.6074 15.0042 2.53258 14.9389C2.45775 14.8737 2.39651 14.7943 2.35235 14.7054C2.30819 14.6165 2.28197 14.5197 2.2752 14.4207C2.26843 14.3216 2.28123 14.2222 2.31288 14.1281C2.34452 14.034 2.3944 13.9471 2.45965 13.8722C2.52489 13.7974 2.60424 13.7362 2.69316 13.692C4.17219 12.9571 5.49602 11.9444 6.5925 10.7093C5.91778 9.79776 5.35338 8.80949 4.9111 7.76518C4.83293 7.58059 4.8313 7.37251 4.90655 7.18672C4.9818 7.00093 5.12778 6.85264 5.31237 6.77448C5.49695 6.69631 5.70503 6.69468 5.89082 6.76993C6.07662 6.84518 6.22491 6.99116 6.30307 7.17574C6.64408 7.98163 7.06643 8.75062 7.56355 9.47076C8.45664 8.17759 9.10397 6.73102 9.47317 5.20341H3.02944C2.8369 5.203 2.65177 5.12912 2.51186 4.99683C2.37194 4.86455 2.2878 4.68385 2.27662 4.49163C2.26543 4.29941 2.32804 4.11017 2.45166 3.96255C2.57528 3.81493 2.75058 3.72006 2.94178 3.69732L3.02944 3.69203H6.80787V2.93635C6.80787 2.73593 6.88748 2.54372 7.0292 2.402C7.17092 2.26028 7.36313 2.18066 7.56355 2.18066H7.56431ZM12.8541 10.6715L11.4304 13.5159H14.2748L12.8534 10.6715H12.8541Z'
                  fill='url(#paint0_linear_5088_34171)'
                />
                <path
                  d='M11.34 4.18553L11.2122 3.84013C12.2541 3.45456 13.0757 2.63303 13.4612 1.59106L13.8066 1.71887L13.4612 1.59106L13.5318 1.40045C13.7113 0.915128 14.3978 0.915127 14.5774 1.40045L14.6479 1.59106L14.3025 1.71887L14.6479 1.59106C15.0335 2.63303 15.855 3.45456 16.897 3.84013L17.0876 3.91066C17.5729 4.09024 17.5729 4.77668 17.0876 4.95626L16.897 5.02679C15.855 5.41236 15.0335 6.23389 14.6479 7.27586L14.5774 7.46647C14.3978 7.95179 13.7113 7.95179 13.5318 7.46647L13.4612 7.27586C13.0757 6.23389 12.2541 5.41236 11.2122 5.02679L11.34 4.68139L11.2122 5.02679L11.0215 4.95626M11.34 4.18553L11.0215 4.95626M11.34 4.18553L11.2122 3.84013L11.0215 3.91066C10.5362 4.09024 10.5362 4.77668 11.0215 4.95626M11.34 4.18553L11.0215 4.95626'
                  fill='url(#paint1_linear_5088_34171)'
                  stroke='white'
                  strokeWidth='0.833333'
                />
                <defs>
                  <linearGradient
                    id='paint0_linear_5088_34171'
                    x1='6.73953'
                    y1='27.5381'
                    x2='28.656'
                    y2='16.0285'
                    gradientUnits='userSpaceOnUse'
                  >
                    <stop stopColor='#8D71FF' />
                    <stop offset='0.673993' stopColor='#197AF7' />
                  </linearGradient>
                  <linearGradient
                    id='paint1_linear_5088_34171'
                    x1='12.8353'
                    y1='11.4517'
                    x2='21.4774'
                    y2='6.91294'
                    gradientUnits='userSpaceOnUse'
                  >
                    <stop stopColor='#8D71FF' />
                    <stop offset='0.673993' stopColor='#197AF7' />
                  </linearGradient>
                </defs>
              </svg>
              {/* {transData.isOriginal ? "Show translation" : "Show original text"} */}
              {transData.isOriginal ? aiTranslate?.translationText : aiTranslate?.originalText}
            </span>
          </Popover>
        </div>
      </div>
    );
  }
  return null;
}
